import * as React from 'react';
import Icons from '../icons';

export default class Emptylogs extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptylog" className="" />  <br />  
                <h2>No logs found</h2>
                <p>Events happening with respect to the {this.props.type} would be available here.</p>
            </div>
        );
    }
}